import { Component, OnInit } from '@angular/core';
import { MissingTranslationHandler } from '@ngx-translate/core';

export function downloadObjectAsJson(exportObj, exportName) {
  const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportObj));
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', exportName + '.json');
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

@Component({
  selector:    'dx-download-missing-translation',
  templateUrl: './download-missing-translation.component.html',
  styleUrls:   [ './download-missing-translation.component.scss']
})
export class DownloadMissingTranslationComponent {

  constructor(public mth: MissingTranslationHandler) {}

  download() {
    downloadObjectAsJson(this.mth['missingTranslation'] || {}, 'missingTranslation');
  }

}
